import { getAxiosClient } from './index';

export const authenticate = (email: string, password: string) => {
    const restClient = getAxiosClient();
    return restClient.post('/company/login', { email, password });
};
